<template>
  <section class="main">

    <div v-if="isLoading" class="loader-container">
      <loader size="50px" />
    </div>

    <template v-else>
      <div v-if="description" class="section">
        <v-markdown :content="description" />
      </div>

      <div v-if="whatsnew" class="section">
        <h2 class="h2">{{ $t('WHATSNEW') }}</h2>
        <v-markdown :content="whatsnew" />
      </div>
    </template>
  </section>
</template>

<script>
import Loader from '@/components/Loader';
import VMarkdown from '@/components/VMarkdown.vue';

export default {
  components: { Loader, VMarkdown },
  data() {
    return {
      isLoading: true,
      description: '',
      whatsnew: '',
    };
  },
  computed: {
    title() {
      return this.$t('APPDB_TOOLS_PAGE_TITLE');
    },
    metaInfo() {
      return {
        title: this.$t('APPDB_TOOLS_PAGE_TITLE'),
        meta: [
          {
            name: 'description',
            content: this.$t('APPDB_TOOLS_PAGE_META_DESCRIPTION'),
          },
          {
            name: 'keywords',
            content: this.$t('APPDB_TOOLS_PAGE_META_KEYWORDS'),
          },
        ],
      };
    },
  },
  async created() {
    try {
      const response = await this.$api.call('get_defaults', { for: 'appdb_tools_md' }, false);

      if (response.success && response.data) {
        this.description = response.data.description || '';
        this.whatsnew = response.data.whatsnew || '';
      } else {
        console.error('Failed to fetch markdown content:', response);
      }
    } catch (error) {
      console.error('Error fetching markdown content:', error);
    } finally {
      this.isLoading = false;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: block;
}

.loader-container {
  display: flex;
  justify-content: center;
  padding: 50px 0;
}

.h2 {
  color: var(--text-tertiary);
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  @include notebook {
    margin-bottom: 10px;
  }
}

.section {
  margin-bottom: 30px;

  :deep(img) {
    max-height: 140px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
